import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnLoginPageModule } from './pages/dn-login-page/dn-login-page.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NyzeAnimationModule } from '../nyze.module';

@NgModule({ declarations: [],
    exports: [DnLoginPageModule],
imports: [CommonModule,
        DnLoginPageModule,
        NyzeAnimationModule],
providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DnLoginModule {
  static forRoot(environment: any): ModuleWithProviders<DnLoginModule> {
    return {
      ngModule: DnLoginModule,
      providers: [
        {
          provide: 'env',
          useValue: environment,
        },
      ],
    };
  }
}
